




































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {ReceiptPickingListStore} from "@/modules/receiptsexpenses/receiptpickinglist/store";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {DebtEmployeeType, ReceiptPaymentType} from "@/enums/type";
import {DebtEmployee} from "@/interfaces/entity";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingStatus} from "@/enums/status";

@Component({
    name: "ReceiptEmployeePickingListPrint",
    components: {LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
    @Prop({ required: true }) readonly id!: any;

    ReceiptPaymentType = ReceiptPaymentType;
    DebtEmployeeType = DebtEmployeeType;
    LadingStatus = LadingStatus;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    get pickingList(): ReceiptExpensePickingList {
        return ReceiptPickingListStore.data[this.id];
    }

    get debts(): Array<DebtEmployee> {
        return this.getProp(this.pickingList, 'debtEmployees', []);
    }

    get totalReceiverCollect() {
        const debtDeliveries = this.debts.filter((debt: DebtEmployee) => debt.type === DebtEmployeeType.Delivery);
        return debtDeliveries.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.money || 0);
        }, 0);
    }

    get totalFee() {
        const debtReceivers = this.debts.filter((debt: DebtEmployee) => debt.type === DebtEmployeeType.Receiver);
        return debtReceivers.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.money || 0);
        }, 0);
    }
}
